<div>
  {{ body }}
</div>
<br>
<div>
  {{ linkLabel }}<a class="link" href="{{ linkRef }}">{{ linkText }}</a>
</div>
